import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { 
  BottomContainer, 
  HeadlineHr, 
  HeadlineParagraph,
  PageContainer, 
  PageHeadline, 
  TopContainer,
  ButtonCTA,
  baseFontSize
} from '~/components/layout/PageBasics';
import { breakpoints, calcEm, css, fluidRange, respondTo, styled } from '~/styles';
import BottomBlockLink from '~/components/layout/BottomBlockLink';
import backgroundImg from '~/assets/images/resources-background.jpg';
import Img1 from '~/assets/images/content/box-resources-01.png';
import Img2 from '~/assets/images/content/box-resources-02.png';

import config from '~/config';

const StyledTopContainer = styled(TopContainer)`
  min-height: 6em;
  justify-content: flex-start;
  ${fluidRange('paddingTop', '20px', '50px')}
  
  // ${respondTo(breakpoints.md, css`
  //   padding-bottom: ${calcEm(170, baseFontSize)}
  // `)}

  &:before {
    background-position: center top;
  }


  @media (max-width: 575px) {
    padding-bottom: 140px;
  }

  @media (min-width: 576px) and (max-width: 1023px) {
    padding-bottom: 240px;
  }

  @media (min-width: 1024px) and (max-width: 1319px) {
    &:before {
      background-position: center;
    }
  }

  @media (min-width: 1320px) and (max-height: 1023px) {
    &:before {
      background-position: center top -170px;
    }
  }

  @media (min-width: 1600px) and (max-height: 1200px) {
    &:before {
      background-position: center bottom -170px;
    }
  }

  @media (min-width: 1600px) and (min-height: 1201px) {
    &:before {
      background-position: center bottom;
    }
  }
  
`

const StyledHeadlineParagraph = styled(HeadlineParagraph)`
  width: ${calcEm(780, 18)};
`

function ResourcesPage() {
  useEffect(() => {
    document.title = config.title + ' | Resources';
  }, []);

  return (
    <PageContainer>
      <StyledTopContainer bgImage={backgroundImg} addGradient={true}>
        {/* <PageHeadline>Reso<b>u</b>rces</PageHeadline> */}
        <PageHeadline>Welcome to the<br/> <span>reso<b>u</b>rce gallery</span></PageHeadline>
        <HeadlineHr />
        <StyledHeadlineParagraph>
        Browse, view, and download resources curated specifically for you, your staff, and your patients.
        </StyledHeadlineParagraph>
        <ButtonCTA size='medium' variant='primary' icon='arrow_right' iconPos='right'
          as={Link}
          to='/resources/gallery'>
          Enter resources
        </ButtonCTA>
      </StyledTopContainer>
      <BottomContainer>
        <BottomBlockLink
          as='a'
          title='Read Article'
          description='Efficacy and Safety of Two Resilient Hyaluronic Acid Fillers in the Treatment of Moderate-to-Severe Nasolabial Folds. Gary Monheit, MD, et al. <i>Dermatologic Surgery</i>. March 24, 2020.'
          bgImg={Img1}
          externalLink='true'
          href='https://journals.lww.com/dermatologicsurgery/Abstract/2020/12000/Efficacy_and_Safety_of_Two_Resilient_Hyaluronic.11.aspx'
        />
        <BottomBlockLink
          as='a'
          href='/assets/files/Combined_IF_Usfor_Gallery_a8cb2bd0cf.pdf'
          target='_blank'

          title='View Instructions for Use'
          description='Instructions for Use for you and your patients'
          bgImg={Img2}
          bgImgAlign='left'
        />
      </BottomContainer>
    </PageContainer>
  );
}

export default ResourcesPage;



// WEBPACK FOOTER //
// ./src/pages/resources/index.tsx